export const ActionTypes = {
  SET_MEDICINES: "SET_MEDICINE",
  REMOVE_SELECTED_MEDICINE: "REMOVE_SELECTED_MEDICINE",
};
